import { render, staticRenderFns } from "./safetyCheckDetail.vue?vue&type=template&id=35ea5589"
import script from "./safetyCheckDetail.vue?vue&type=script&lang=js"
export * from "./safetyCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ea5589')) {
      api.createRecord('35ea5589', component.options)
    } else {
      api.reload('35ea5589', component.options)
    }
    module.hot.accept("./safetyCheckDetail.vue?vue&type=template&id=35ea5589", function () {
      api.rerender('35ea5589', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspection/safetyCheckDetail.vue"
export default component.exports